var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProvider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000002221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#FB140C"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "url(#paint0_linear_1_3190)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1158 23.013C10.0514 23.0261 10 23.0782 10 23.1434V23.1564V23.1694V23.1955C11.2476 29.4645 14.7974 34 18.9904 34C20.328 34 24.4952 34 25.8971 24.8116C25.9228 24.6422 25.717 24.577 25.6656 24.7334C25.0096 26.9882 23.6849 30.6505 22 30.6505C20.791 30.6505 19.3891 28.7607 17.9228 23.1043C17.91 23.0521 17.8714 23.013 17.8071 23L10.1158 23.013ZM27.0289 23.013C26.9646 23.013 26.9132 23.0652 26.9132 23.1303C26.4373 27.9656 25.2154 31.4846 23.119 33.4265C23.0547 33.4787 23.0547 33.5829 23.1061 33.6351C23.119 33.6481 23.1318 33.6611 23.1447 33.6742C23.7492 33.8697 24.3794 33.9739 25.0096 33.9739C29.2283 33.9739 32.7781 29.3602 34 23.1434C34 23.0652 33.9486 23.013 33.8842 23L27.0289 23.013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 20.8565C10 20.9348 10.0514 20.987 10.1157 21H16.9796C17.0439 21 17.0953 20.9478 17.0953 20.8826C17.5837 16.0415 18.792 12.5184 20.8872 10.5741C20.9514 10.5089 20.9514 10.4176 20.8872 10.3523C20.8743 10.3393 20.8615 10.3262 20.8486 10.3262C20.2445 10.1305 19.6146 10.0261 18.9848 10.0261C14.7816 10.013 11.2211 14.6323 10 20.8565ZM25.0132 10C23.6764 10 19.5118 10 18.1107 19.1993C18.085 19.3689 18.2907 19.4342 18.3421 19.2776C18.9977 17.0071 20.3216 13.3405 22.0054 13.3405C23.2137 13.3405 24.6148 15.2325 26.0801 20.8956C26.0929 20.9478 26.1315 20.987 26.1958 21H33.8823C33.9595 20.987 34.0109 20.9217 33.998 20.8434V20.8173C32.7512 14.5409 29.2036 10 25.0132 10Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3190",
    x1: 2.47891,
    y1: 22.0005,
    x2: 42.8506,
    y2: 22.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED2024"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvider);
export default __webpack_public_path__ + "static/media/provider.feb8b982e8108d8dbc067199fb0ecb8c.svg";
export { ForwardRef as ReactComponent };